import { render, staticRenderFns } from "./PriceRangeFilter.vue?vue&type=template&id=8ff380a8&scoped=true"
import script from "./PriceRangeFilter.vue?vue&type=script&lang=js"
export * from "./PriceRangeFilter.vue?vue&type=script&lang=js"
import style0 from "./PriceRangeFilter.vue?vue&type=style&index=0&id=8ff380a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff380a8",
  null
  
)

export default component.exports